// @ts-ignore
import { ProjektKontierungApi, Configuration } from "../generated";
import { fetchApi } from "./ApiErrorFetch";

const ProjektKontieurng = new ProjektKontierungApi(
  new Configuration({ basePath: window.location.origin, fetchApi: fetchApi})
);

export default ProjektKontieurng;